// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604301153/js/" + chunkId + "." + {"44":"708c6b58","225":"1b0808c8","481":"fff29321","486":"e8410d38","770":"1145e402"}[chunkId] + ".0.03413010855500809.chunk.js";
};